import { Dialog } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  padding: 24px;
`;

export const StyledDialog = styled(Dialog)<{ isFullScreenMode: boolean }>`
  z-index: 10000;

  .vehicle-questions {
    border-radius: 20px;
    background: #fff;
    margin: ${props => (props.isFullScreenMode ? '18px' : '110px 18px')};
    margin: 18px;
    height: ${props => (props.isFullScreenMode ? 'calc(100vh - 36px)' : 'calc(100vh - 120px)')};
    width: 100%;
    transition: height 0.5s cubic-bezier(0.4, 0, 0.2, 1) !important;
    max-height: none;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    z-index: 10000;
  }

  @media (orientation: landscape) {
    .vehicle-questions {
      height: 100vh;
    }
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const Title = styled.div`
  font-size: 22px;
  font-weight: 500;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const QuestionsWrapper = styled.div<{ withPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: scroll;
  padding: ${props => (props.withPadding ? '1px' : 0)};
  max-height: calc(100vh - 360px);
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1) !important;

  @media (orientation: landscape) {
    max-height: calc(100vh - 140px);
  }
`;

export const SectionGroupLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: rgb(0, 0, 0);
  padding: 8px 0;
`;

export const EmptyText = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: rgb(0, 0, 0);
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
